import type { ReactNode } from 'react';
import { Logo } from '../../components/Logo';
import './auth.css';

const SPARKS = Array.from({ length: 14 }, (_, i) => ({
  left: `${(i * 37) % 100}%`,
  delay: `${(i * 0.43) % 6}s`,
  drift: `${((i * 53) % 80) - 40}px`,
}));

export function AuthLayout({ title, subtitle, children, testId }: { title: string; subtitle?: ReactNode; children: ReactNode; testId: string }) {
  return (
    <main className="auth-screen" data-testid={testId}>
      <div className="auth-sparks" aria-hidden="true">
        {SPARKS.map((s, i) => (
          <span key={i} style={{ left: s.left, animationDelay: s.delay, ['--drift' as string]: s.drift }} />
        ))}
      </div>
      <section className="auth-card">
        <header>
          <Logo size={56} />
          <h1>{title}</h1>
          {subtitle && <p className="muted" style={{ margin: 0 }}>{subtitle}</p>}
        </header>
        {children}
      </section>
    </main>
  );
}
